import { useEffect, useRef } from 'react';
import { useUser } from '../../hooks/useUser';
import { useCompany } from '../../hooks/useCompany';
import { useUserAssociations } from '../../hooks/useUserAssociations';

/**
 * Composant responsable du préchargement automatique des données
 * utilisateur et entreprise dès la connexion
 */
export function DataPreloader() {
  const { user, isLoading: isUserLoading, isAuthenticated } = useUser();
  const preloadingStartedRef = useRef(false);
  
  // Précharger les données de l'entreprise automatiquement
  const { 
    company, 
    loading: companyLoading 
  } = useCompany(user?.companyId, { 
    enabled: !isUserLoading && !!user?.companyId,
    preferMock: false 
  });

  // Précharger les associations utilisateur
  const { 
    isCheckingAssociations 
  } = useUserAssociations();

  useEffect(() => {
    // Éviter les multiples déclenchements
    if (preloadingStartedRef.current) return;

    if (isAuthenticated && user && !isUserLoading) {
      preloadingStartedRef.current = true;
      
      console.log('🚀 DataPreloader - Démarrage du préchargement des données:', {
        userId: user.id,
        userName: user.name,
        hasCompanyId: !!user.companyId,
        userType: user.userType
      });

      // Le préchargement se fait automatiquement via les hooks
      // useCompany et useUserAssociations ci-dessus
    }
  }, [isAuthenticated, user, isUserLoading]);

  // Log du statut de préchargement
  useEffect(() => {
    if (preloadingStartedRef.current) {
      console.log('📊 DataPreloader - Statut du préchargement:', {
        userLoaded: !!user && !isUserLoading,
        companyLoaded: !!company && !companyLoading,
        associationsLoaded: !isCheckingAssociations,
        userCompanyId: user?.companyId || 'NONE',
        hasCompanyData: !!company,
        companyName: company?.name || 'NONE'
      });

      // Si tout est chargé, log de succès
      if (user && !isUserLoading && 
          (!user.companyId || (user.companyId && company && !companyLoading)) &&
          !isCheckingAssociations) {
        
        console.log('✅ DataPreloader - Préchargement terminé avec succès:', {
          user: user.name,
          company: company?.name || 'Aucune entreprise',
          loadedAt: new Date().toISOString()
        });
      }
    }
  }, [user, isUserLoading, company, companyLoading, isCheckingAssociations]);

  // Ce composant ne rend rien, il sert juste à précharger les données
  return null;
}
